import { Translations } from './en';

export const bg: Translations = {
   'components.language.label': 'Език',
   'components.footer.policy': 'Политика за поверителност',
   'components.login-link.home': 'Начало',
   'components.login-link.login': 'Вход',
   'components.login-link.logout': 'Изход',
   'pages.login-page.login': 'Вход',
   'pages.login-page.register': 'Регистрация',
   'pages.login-page.signInWithGoogle': 'Вход с Google',
   'pages.login-page.orEmail': 'или с имейл',
   'pages.login-page.email': 'Имейл адрес',
   'pages.login-page.password': 'Парола',
   'pages.login-page.noAccount': 'Нямате акаунт?',
   'pages.login-page.haveAccount': 'Вече имате акаунт?',
   'pages.login-page.errorWrongPassword': 'Грешен имейл или парола.',
   'pages.login-page.errorEmailInUse': 'Този имейл вече е регистриран.',
   'pages.login-page.errorWeakPassword': 'Паролата трябва да е поне 6 символа.',
   'pages.login-page.errorGeneral': 'Грешка при вход. Опитайте отново.',
   'pages.login-page.forgotPassword': 'Забравена парола?',
   'pages.forgot-password-page.title': 'Забравена парола',
   'pages.forgot-password-page.description': 'Въведете имейл адреса си и ще ви изпратим линк за нова парола.',
   'pages.forgot-password-page.email': 'Имейл адрес',
   'pages.forgot-password-page.submit': 'Изпрати линк',
   'pages.forgot-password-page.success': 'Имейл за смяна на паролата беше изпратен. Проверете входящата си поща.',
   'pages.forgot-password-page.errorInvalidEmail': 'Невалиден или непознат имейл адрес.',
   'pages.forgot-password-page.errorGeneral': 'Грешка. Опитайте отново.',
   'pages.forgot-password-page.backToLogin': 'Обратно към вход',
   'components.navbar.cookies.policy': 'С използването на този сайт, вие се съгласявате с използването на бисквитки.',
   'components.navbar.cookies.accept': 'Приемам',
   'components.navbar.menu': 'Меню',
   'components.navbar.darkTheme': 'Тъмна тема',
   'components.navbar.myShops': 'Моите магазини',
   'pages.index-page.welcome': 'Търсачка, която клиентите ви наистина ще ползват',
   'pages.index-page.subtitle': 'Умно търсене за вашия онлайн магазин. Разбира латиница, грешки и „до 50 лв.“',
   'pages.index-page.try.label': 'Адрес на магазина или продуктов фийд',
   'pages.index-page.try.submit': 'Пробвай върху моя магазин',
   'pages.index-page.try.reading': 'Четем каталога ви… може да отнеме до минута.',
   'pages.index-page.try.ready': 'Прочетохме {{ count }} продукта от {{ name }}. Потърсете така, както биха търсили клиентите ви:',
   'pages.index-page.try.searchPlaceholder': 'напр. telefon samsung, слушалки до 50 лв.',
   'pages.index-page.try.noResults': 'Няма намерени продукти.',
   'pages.index-page.try.popular': 'Най-търсени',
   'pages.index-page.try.examples': 'Опитайте:',
   'pages.index-page.try.similarButton': 'Подобни',
   'pages.index-page.try.similar': 'Подобни на „{{ title }}“',
   'pages.index-page.try.similarHint': 'Така ги показва <div data-oopsy-similar> на продуктовата страница.',
   'pages.index-page.try.total': 'Намерени: {{ count }}',
   'pages.index-page.try.under': 'до {{ price }}',
   'pages.index-page.try.install': 'Сложи го в моя магазин',
   'pages.index-page.try.another': 'Друг магазин',
   'pages.index-page.outOfStock': 'Изчерпан',
   'errors.invalid-url': 'Това не прилича на уеб адрес.',
   'errors.unreachable': 'Не успяхме да отворим адреса. Проверете го и опитайте отново.',
   'errors.blocked': 'Сайтът блокира автоматичното четене. Поставете продуктовия си фийд, напр. този за Pazaruvaj или Google Shopping.',
   'errors.no-products': 'Не намерихме продукти там. Поставете линка към продуктовия си фийд.',
   'errors.too-many-shops': 'Можете да добавите до 5 магазина.',
   'errors.general': 'Нещо се обърка. Опитайте отново.',
   'pages.index-page.how.title': 'Как работи',
   'pages.index-page.how.step1': 'Въведете адреса на магазина си',
   'pages.index-page.how.step2': 'Търсете в своите продукти',
   'pages.index-page.how.step3': 'Сложете го с един ред код',
   'pages.shops-page.loading': 'Зареждаме магазините ви',
   'pages.shops-page.title': 'Моите магазини',
   'pages.shops-page.loginRequired': 'Влезте, за да добавите магазина си.',
   'pages.shops-page.add': 'Добави магазин',
   'pages.shops-page.empty': 'Още нямате магазини. Добавете адреса на магазина си отгоре.',
   'pages.shops-page.products': '{{ count }} продукта',
   'pages.shops-page.active': 'Търсачката работи',
   'pages.shops-page.notInstalled': 'Още не е инсталирана',
   'pages.shop-page.status.working': 'Търсачката работи',
   'pages.shop-page.status.waiting': 'Чака инсталиране',
   'pages.shop-page.status.products': '{{ count }} продукта',
   'pages.shop-page.insights.title': 'Какво търсят клиентите',
   'pages.shop-page.settings.title': 'Магазин и план',
   'pages.shop-page.plan.title': 'План',
   'pages.shop-page.install.title': 'Инсталиране',
   'pages.shop-page.install.text': 'Поставете този ред точно преди </body> на всяка страница на {{ host }}. Той поема търсачката, която вече имате.',
   'pages.shop-page.install.custom': 'Ако търсачката ви не бъде открита, добавете data-input="#id-на-полето-за-търсене" към реда.',
   'pages.shop-page.install.copy': 'Копирай',
   'pages.shop-page.install.copied': 'Копирано',
   'pages.shop-page.install.active': 'Работи: последно търсене от сайта ви {{ date }}.',
   'pages.shop-page.install.waiting': 'Чакаме първото търсене от сайта ви.',
   'pages.shop-page.try.title': 'Пробвайте',
   'pages.shop-page.catalogue.title': 'Каталог',
   'pages.shop-page.catalogue.text': '{{ count }} продукта от {{ source }}, прочетени {{ date }}. Четем ги отново всяка нощ.',
   'pages.shop-page.catalogue.refresh': 'Прочети отново сега',
   'pages.shop-page.catalogue.error': 'Последното опресняване не успя. Търсенето използва каталога, прочетен {{ date }}.',
   'pages.shop-page.source.feed': 'фийда ви',
   'pages.shop-page.source.shopify': 'Shopify',
   'pages.shop-page.source.woocommerce': 'WooCommerce',
   'pages.shop-page.source.sitemap': 'продуктовите ви страници',
   'pages.shop-page.top.title': 'Най-търсени',
   'pages.shop-page.notFound.title': 'Търсено, но ненамерено',
   'pages.shop-page.notFound.hint': 'Какво са искали клиентите, а търсенето не им е показало.',
   'pages.shop-page.stats.empty': 'Още няма търсения от сайта ви.',
   'pages.shop-page.stats.times': '{{ count }}×',
   'pages.shop-page.remove': 'Премахни магазина',
   'pages.shop-page.removeConfirm': 'Да премахнем ли магазина? Търсачката на сайта ви ще спре да работи.',
   'pages.index-page.try.understood': 'Търсим: {{ what }}',
   'pages.shop-page.plan.free': 'Безплатен план',
   'pages.shop-page.plan.pro': 'Pro',
   'pages.shop-page.plan.freeText': 'Всичко включено: до {{ count }} продукта и {{ searches }} търсения на месец, каталогът се чете отново всяка седмица.',
   'pages.shop-page.plan.proText': 'До {{ count }} продукта, неограничени търсения, каталогът се чете отново всяка нощ.',
   'pages.shop-page.plan.upgrade': 'Искам Pro',
   'pages.shop-page.notFound.locked': '{{ count }} различни търсения не са намерили нищо. Списъкът е в Pro.',
   'pages.shop-page.recommendations.title': 'Препоръки',
   'pages.shop-page.recommendations.text': 'Сложете този елемент на продуктовата страница там, където искате „Подобни продукти“. Редът от „Инсталиране“ трябва също да е на страницата.',
   'pages.shop-page.recommendations.picks': 'Най-избирани продукти',
   'pages.shop-page.recommendations.picksHint': 'Какво отварят клиентите от резултатите и от подобните продукти. Търсенето ги класира малко по-високо.',
   'pages.shop-page.recommendations.locked': '„Подобни продукти“ на всяка продуктова страница и най-избираните продукти, когато търсенето не намери нищо, са в Pro.',
   'pages.shop-page.catalogue.textManual': '{{ count }} продукта от {{ source }}, прочетени {{ date }}.',
   'pages.shop-page.catalogue.textWeekly': '{{ count }} продукта от {{ source }}, прочетени {{ date }}. Четем ги отново всяка седмица.',
   'pages.shop-page.plan.paused': 'Търсенията за месеца са изчерпани: AI е спрян до 1-во число. Обикновеното търсене работи.',
   'pages.shop-page.plan.usage': 'Този месец: {{ used }} от {{ limit }} търсения от сайта ви.',
   'pages.shop-page.catalogue.nextRefresh': 'Може да го прочетете отново от {{ date }}.',
   'errors.feed-needed': 'Безплатният план чете продуктов фийд, Shopify или WooCommerce. Поставете линка към фийда си или поискайте Pro.',
   'errors.refresh-too-soon': 'В безплатния план каталогът може да се чете ръчно веднъж на ден.',
};
